<section class="relative lg:flex lg:items-center md:sm:grid md:sm:grid-cols-1 gap-4">
  <article class="lg:flex rounded h-10">
    <app-input-search [placeholder]="searchPlaceholder()" [searchValue]="searchValue()" (submitEventEmitter)="search.emit($event)" />
  </article>
  <ng-content select="[listToolbar]" />
  @if (filterType(); as type) {
    <article class="relative lg:flex rounded" (click)="filterOpened.set(!filterOpened())">
      <button
        id="managementListFilterButton"
        class="management-filter-button font-bold py-2 px-4 rounded inline-flex items-center cursor-pointer"
        [class.opened]="filterOpened()"
        [class.filtersApplied]="filtersApplied() > 0"
      >
        <img [src]="images.filter" alt="" class="w-6 h-6 mr-2" [class.filter-primary-purple-light]="filterOpened() || filtersApplied() > 0" />
        <span class="font-semibold text-base">{{ literalService.get('users.filter', true) }}</span>
      </button>
      @if (filtersApplied() > 0) {
        <div class="text-white bg-primary-purple-light w-4 h-4 absolute -top-2 -right-2 flex justify-center items-center p-2.5 rounded-full text-xs font-bold">{{ filtersApplied() }}</div>
      }
    </article>
    <article class="flex absolute left-0 top-full mt-3 w-max max-w-[90vw] z-40" [class.hidden]="!filterOpened()">
      <app-filter-panel
        [componentOpen]="'managementListFilterButton'"
        [fields]="filterFields()"
        [filterType]="type"
        [selection]="filterSelection()"
        (filter)="onFilter($event)"
        (closeFilter)="filterOpened.set(false)"
      />
    </article>
  }
  <section class="flex ml-auto max-h-10">
    <a class="rounded-[30px] px-3 py-1.5 inline-flex gap-1 justify-center items-center cursor-pointer outlinedButton" (click)="create.emit()">
      <img [src]="createIcon()" alt="" class="w-5.5 h-5.5" />
      <span class="font-semibold text-base text-primary-purple">{{ literalService.get(createLabel(), true) }}</span>
    </a>
  </section>
</section>

<div class="grid mt-6 mb-4 text-center" [style.grid-template-columns]="gridTemplateColumns()">
  @for (column of columnHeaders(); track column.label) {
    <label class="flex justify-center items-center font-semibold text-base" [style.grid-column]="column.gridColumn">
      <img [src]="column.icon" alt="" class="h-6 w-6 mr-2 filter-primary-purple-light" />
      {{ literalService.get(column.label, true) }}
    </label>
  }
</div>

<div class="scrollable-content max-h-[calc(100vh-310px)] h-full mb-5">
  @if (loading()) {
    <ngx-skeleton-loader [count]="skeletonRows()" appearance="line" [theme]="{ height: '40px' }" />
  } @else if (empty()) {
    <div class="flex flex-col justify-center items-center h-[calc(100vh-360px)]">
      <img [src]="images.booking.empty" alt="" class="h-48" />
      <label class="mt-4 font-bold text-lg text-center uppercase text-neutrals-grey-04">{{ literalService.get(emptyText(), true) }}</label>
    </div>
  } @else {
    @for (item of items(); track item.id) {
      <a
        href=""
        class="management-row selectable-row border rounded pt-2 pb-2 grid justify-center items-center mb-4 cursor-pointer no-underline text-base text-center"
        [style.grid-template-columns]="gridTemplateColumns()"
        [class.selected-row]="item.id === selectedId()"
        [class.inactive]="item.active === false"
        (click)="$event.preventDefault(); selectItem.emit(item)"
      >
        <ng-container [ngTemplateOutlet]="rowTemplate()" [ngTemplateOutletContext]="{ $implicit: item }" />
      </a>
    }
  }
</div>

@if (!empty()) {
  <section class="relative h-14">
    <app-pagination [pagination]="pagination()" [loading]="loading() && !pagination().totalPages" (changePage)="changePage.emit($event)" />
  </section>
}
